



















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class Video extends Vue {
  // 参数
  @Prop() public src!: string; //视频链接
  @Prop({
    type: String,
    required: false,
    default: ''
  })
  private poster!: string; //视频封面
  @Prop({
    type: String,
    required: false,
    default: undefined
  })
  private aspectRatio!: any; // 视频比例
  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  private autoPlay!: boolean; //是否自动播放
  @Prop({
    type: Boolean,
    required: false,
    default: true
  })
  private isCanClose!: boolean; //是否自动播放
  @Prop({
    type: Boolean,
    required: false,
    default: true
  })
  private isCanSuspend!: boolean; //是否可以暂停
  public isActiveVideo: boolean = false;
  public isPlay: boolean = false; //是否在播放中
  public playerOptions: object = {
    controls: false, // 禁止操作视频
    playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
    autoplay: false, // 如果为true,浏览器准备好时开始回放
    muted: this.autoPlay, // 默认情况下将会消除任何音频。
    loop: true, // 是否视频一结束就重新开始。
    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
    language: 'zh-CN',
    aspectRatio: this.aspectRatio, // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
    sources: [
      {
        type: 'video/mp4', // 类型
        src: this.src // url地址
      }
    ],
    poster: this.poster, // 封面地址
    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
    controlBar: {
      timeDivider: true, // 当前时间和持续时间的分隔符
      durationDisplay: true, // 显示持续时间
      remainingTimeDisplay: false, // 是否显示剩余时间功能
      fullscreenToggle: true // 是否显示全屏按钮
    }
  };
  handleMouseOver() {
    if (this.autoPlay) {
      this.isActiveVideo = true;
      setTimeout(() => {
        if (this.isActiveVideo) {
          (this.$refs.videoPlayer as any).player.play(); // 播放
        }
      }, 200);
    }
  }
  handleMouseLeave() {
    if (this.autoPlay) {
      this.isActiveVideo = false;
      (this.$refs.videoPlayer as any).player.pause(); // 暂停
    }
  }
  closeVideo() {
    (this.$refs.videoPlayer as any).player.src(this.src);
    (this.$refs.videoPlayer as any).player.pause(); // 暂停
    this.isPlay = false;
  }

  suspendVideo() {
    (this.$refs.videoPlayer as any).player.pause(); // 暂停
    this.isPlay = false;
  }
  onPlayerPlay() {
    // 播放回调
    this.isPlay = true;
  }
  /**
 * 视频空间API Event
 * 
  @play="onPlayerPlay($event)" // 播放回调
  @pause="onPlayerPause($event)"// 暂停回调
  @ended="onPlayerEnded($event)"// 视频播完回调
  @waiting="onPlayerWaiting($event)"// DOM元素上的readyState更改导致播放停止
  @playing="onPlayerPlaying($event)"// 已开始播放回调
  @loadeddata="onPlayerLoadeddata($event)"// 当播放器在当前播放位置下载数据时触发
  @timeupdate="onPlayerTimeupdate($event)"// 当前播放位置发生变化时触发
  @canplay="onPlayerCanplay($event)"// 媒体的readyState为HAVE_FUTURE_DATA或更高
  @canplaythrough="onPlayerCanplaythrough($event)"// 媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件
  @statechanged="playerStateChanged($event)"// 播放状态改变回调
  @ready="playerReadied"// 将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数
 * 
*/
}
